<template>
	<div>
		<myheader :backFlag="true" headTitle="添加印章"></myheader>
		<div class="header_extend_main" style="height: 100%;">
			<div class="header_extend_back" style="height: 3rem;"></div>
			<div class="header_extend_content margin_top_5">
				<div class="all_tips_content_card_padding8">
					<div class="text12 textcolor333 font_weight_bold">{{'企业名称：'+signetInfo.corpName}}</div>
					<div class="text12 textcolor333 font_weight_bold margin_top_5 ">
						{{'统一社会信用代码：'+signetInfo.creditCode}}
					</div>
				</div>
				<div class="all_tips_content_card_padding8 margin_top_8">
					<div class="all_tips_red_after text14 textcolor666">印章名称</div>
					<div class="all_van_field" :class="{ isfocus: signetNameFocus }">
						<van-field v-model="signetName" type="text" placeholder="请输入印章名称" clearable
							@focus="signetNameFocus=true" @blur="signetNameFocus=false"
							@input="onSignetNameChange($event)">
						</van-field>
					</div>
					<div class="all_tips_red_after text14 textcolor666 margin_top_5">印章类型</div>
					<div class="all_van_field display_flex" style="height: 2rem;align-items: center;">
						<span class="display_inline_block text14 textcolor333"
							style="width: 80%;">{{signetTypeText}}</span>
						<span class="display_inline_block display_flex" style="width: 20%;"
							@click="showSealTypeBottom = true">
							<span class="text12 textcolormain all_text_center"
								style="line-height: 1.6rem;width: 2.6rem;">切换</span>
							<img src="@/assets/images/u359.png" style="height: .8rem;margin: .4rem;" />
						</span>
					</div>
				</div>
				<div class="all_tips_content_card_padding8 margin_top_8">
					<div class="display_flex">
						<span style="width: 60%;margin-top: .2rem;"
							class="display_block text14 textcolor666">印模图片</span>
						<span style="width: 40%;height: 1.6rem;"
							class="switchSignetImgStyle display_block display_flex">
							<span class="display_block text12 all_text_center"
								:class="{switchSignetImgStyleon:signetMakeStyle===0,switchSignetImgStyleoff:signetMakeStyle!==0}"
								@click="selectMakeType(0)">上传图片</span>
							<span class="display_block text12 all_text_center"
								:class="{switchSignetImgStyleon:signetMakeStyle!==0,switchSignetImgStyleoff:signetMakeStyle===0}"
								@click="selectMakeType(1)">一键生成</span>
						</span>
					</div>
					<div style="width: 90%;height: 8rem;border-radius: .2rem;border: 1px solid #999;margin: .5rem 5%;">
						<div v-if="signetMakeStyle === 0" class="all_text_center" style="padding-top: .5rem;">
							<van-uploader accept="image/*" v-model="imageFiles" :before-read="beforeRead"
								:after-read="afterRead" preview-size="7rem" :preview-full-image="imageFilePreview">
								<div v-show="imageFiles.length==0" style="justify-content: center; align-items: center;"
									class="vertical_flex">
									<div class="text14 textcolor666">上传企业印章图片</div>
									<img class="margin_top_5" style="width: 3rem; height: 3rem; "
										src="@/assets/images/fang_gallery.svg">
									<div class="text12 textcolor666 margin_top_5" style="padding: 0 5%;">
										建议上传扫描版印章图片，png格式，分辨率为120，宽高为210*210，大小不超过1.5M</div>
								</div>
							</van-uploader>
						</div>
						<div v-else class="display_flex" style="justify-content: center;">
							<div style="width: 8rem; height: 8rem;position: relative;">
								<img id="img" style="width: 8rem; height: 8rem; object-fit: fill;" :src="imgSrc">
								<img style="position: absolute;left: 0;top: 0;z-index: 10;width: 8rem; height: 8rem; object-fit: fill;"
									:src="imgWaterMarker">
							</div>
						</div>
					</div>
				</div>
				<div class="all_tips_bottom_card">
					<button class="all_button22 width_100 text16 bmain_active" @click="sumbit()">提交</button>
				</div>
			</div>
		</div>
		<!-- 选择印章类型 -->
		<van-popup v-model:show="showSealTypeBottom" position="bottom">
			<div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="selectType(4)">
					企业公章</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="selectType(5)">
					人事专用章</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="selectType(1)">
					合同专用章</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="selectType(2)">
					收货确认章
				</div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext text14 textcolor999 backgroundC_white bwhite_ative" @click="selectType(3)">
					交货确认章
				</div>
				<div class="horizontal_line"></div>
				<div style="height:.5rem;background-color: #ededed;"></div>
				<div class="horizontal_line"></div>
				<div class="bottomTooltext all_height_line24 text14 textcolor999" @click="showSealTypeBottom = false">
					取&nbsp;&nbsp;消</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Field,
		Checkbox,
		Uploader,
	} from 'vant';
	export default {
		name: 'addsignet',
		components: {
			[Uploader.name]: Uploader,
			[Field.name]: Field,
		},
		data() {
			return {
				//企业id
				corpId: null,
				//
				signetName: '',
				signetNameFocus: false,
				//制作方式
				signetMakeStyle: 0,
				//印模类型
				signetType: 4,
				signetTypeText: '企业公章',
				//
				showSealTypeBottom: false,
				//选择印模
				imageFiles: [],
				//印模是否可以方法查看
				imageFilePreview: false,
				//印模
				signetFileId: '',
				//生成印模base64
				imgSrc: '',
				//水印base64
				imgWaterMarker: '',
				//印模信息
				signetInfo: '',
				//524288
				imageLimitSize: 204800,
			}
		},
		methods: {
			//提交
			sumbit() {
				if (this.signetMakeStyle === 0) {
					this.saveSignetImg()
				} else {
					this.uploadBase64(0, this.imgSrc)
				}
			},
			//
			saveSignetImg() {
				if (!this.signetName) {
					this.$Toast('请输入印模名称！');
					return
				}
				if (this.signetType === 0 || !this.signetTypeText) {
					this.$Toast('请选择印模类型！');
					return
				}
				if (!this.signetFileId) {
					if (this.signetMakeStyle === 0) {
						this.$Toast('请重新选择印模图片！');
					} else {
						this.$Toast('提交失败，请重试！');
					}
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/corp/api/saveSignet', {
						corpId: this.corpId,
						signetId: this.signetInfo.signetId,
						signetName: this.signetName,
						signetType: this.signetType,
						signetTypeText: this.signetTypeText,
						signetImg: {
							isGenerate: this.signetMakeStyle === 0 ? true : false,
							signetFileId: this.signetFileId,
							signetId: this.signetInfo.signetId,
						}
					})
					.then(res => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success) {
							this.$router.go(-1)
						} else {
							this.$Toast('提交失败，请重试！');
						}
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
						this.$Toast('提交失败，请重试！');
						console.log('saveSignetImg', err)
					})
			},
			//文件长传前
			beforeRead(file) {
				if (file.type === 'image/*') {
					this.$Toast('请选择图片文件');
					return false;
				}
				return true;
			},
			//文件长传后
			afterRead(file) {
				// console.log(this.imageFiles)
				this.imageFilePreview = true
				if (file.file.size > this.imageLimitSize) {
					this.$store.dispatch(this.$LoadShow, true)
					this.Tool.compressImage(file, this.imageLimitSize, true).then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						this.uploadBase64(1, res, file)
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
						this.uploadBase64(1, file.content, file)
					})
				} else {
					this.uploadBase64(1, file.content, file)
				}
			},
			//选印模类型
			selectType(index) {
				switch (index) {
					case 1:
						this.signetTypeText = '合同专用章'
						break;
					case 2:
						this.signetTypeText = '收货确认章'
						break;
					case 3:
						this.signetTypeText = '交货确认章'
						break;
					case 4:
						this.signetTypeText = '企业公章'
						break;
					case 5:
						this.signetTypeText = '人事专用章'
						break;
					// case 6:
					// 	this.signetTypeText = '招标专用章'
					// 	break;
					// case 7:
					// 	this.signetTypeText = '非招标专用章'
					// 	break;
				}
				if (this.signetType !== index) {
					this.makeSignetImg()
				}
				this.signetType = index
				this.showSealTypeBottom = false
			},
			//选印模制作方式
			selectMakeType(type) {
				if (type === 1) {
					if (this.signetName) {
						this.imgSrc = this.Tool.createSeal(this.signetName, this.signetTypeText)
						this.imgWaterMarker = this.Tool.createWaterMarker()
					} else {
						this.$Toast('请输入印模名称！');
						return
					}
				}
				this.signetMakeStyle = type
			},
			//印模名称变化
			onSignetNameChange(value) {
				//console.log('onSignetChange', value)
				if (this.signetMakeStyle === 1) {
					this.imgSrc = this.Tool.createSeal(this.signetName, this.signetTypeText)
					this.imgWaterMarker = this.Tool.createWaterMarker()
				}
			},
			//印模类型变化
			makeSignetImg() {
				if (this.signetName && this.signetMakeStyle === 1) {
					this.imgSrc = this.Tool.createSeal(this.signetName, this.signetTypeText)
					this.imgWaterMarker = this.Tool.createWaterMarker()
				}
			},
			//上传印模图片
			uploadBase64(flag, data, file) {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/file/api/saveBase64?resId=' + this.Tool.generateUUID(), {
						base64Data: data,
						clearBg: flag,
						fileName: file ? this.getImage(file.file.name) : (this.signetName + '.png')
					})
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.signetFileId = res.data.fileId
							if (file) {
								file.status = 'success';
								file.message = '上传成功';
							} else {
								this.saveSignetImg()
							}
						} else {
							if (file) {
								file.status = 'failed';
								file.message = '上传失败';
							} else {
								this.$Toast('提交失败！');
							}
						}
					}).catch(err => {
						this.$store.dispatch(this.$LoadShow, false)
						if (file) {
							file.status = 'failed';
							file.message = '上传失败';
						} else {
							this.$Toast('提交失败！');
						}
						console.log('/file/api/saveBase64', err)
					})
			},
			//
			getImage(imageName) {
				return imageName.replace('.jpg', '.png').replace('.jpeg', '.png')
			},
			//印模信息初始化
			getNewSignet() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$get("/corp/api/getNewSignet", {
					corpId: this.corpId
				}).then(res => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.signetInfo = res.data
					} else {
						this.$Toast('初始化印模失败！');
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					this.$Toast('初始化印模失败！');
					console.log('getNewSignet', err)
				})
			},
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				this.getNewSignet()
			},
		},
		mounted() {
			this.init()
		},
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	::v-deep .van-cell {
		padding: .5rem .2rem;
	}
</style>